module.exports = __webpack_public_path__ + "static/media/opakowania_5_B.087a9636.png";